/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptAnalyticsKpiSummaryResponse {
    getFixupPrototypeFunction() { return PromptAnalyticsKpiSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<PromptAnalyticsKpiSummaryResponse>): PromptAnalyticsKpiSummaryResponse {
        let obj = Object.assign(new PromptAnalyticsKpiSummaryResponse(), model);
        PromptAnalyticsKpiSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptAnalyticsKpiSummaryResponse>): PromptAnalyticsKpiSummaryResponse {
        if (!model) return null;
        return PromptAnalyticsKpiSummaryResponse.newInstance(<PromptAnalyticsKpiSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptAnalyticsKpiSummaryResponse) {
        if (!obj) return;

        models.PromptAnalyticsKpiSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptAnalyticsKpiSummaryResponse): boolean {
        Object.setPrototypeOf(obj, PromptAnalyticsKpiSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.models) {
            for (let val of this.models) {
                models.AiGovernanceModelSummary.fixupPrototype(val);
            }
        }
        if (this.high_latency_prompts) {
            for (let val of this.high_latency_prompts) {
                models.AiGovernancePromptSummary.fixupPrototype(val);
            }
        }
        if (this.low_latency_prompts) {
            for (let val of this.low_latency_prompts) {
                models.AiGovernancePromptSummary.fixupPrototype(val);
            }
        }
        if (this.high_cost_prompts) {
            for (let val of this.high_cost_prompts) {
                models.AiGovernancePromptSummary.fixupPrototype(val);
            }
        }
        if (this.low_cost_prompts) {
            for (let val of this.low_cost_prompts) {
                models.AiGovernancePromptSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Model Summary For the Prompts
     */
    models: Array<models.AiGovernanceModelSummary>;

    /**
     * Model Summary For the Prompts
     */
    high_latency_prompts: Array<models.AiGovernancePromptSummary>;

    /**
     * Model Summary For the Prompts
     */
    low_latency_prompts: Array<models.AiGovernancePromptSummary>;

    /**
     * Model Summary For the Prompts
     */
    high_cost_prompts: Array<models.AiGovernancePromptSummary>;

    /**
     * Model Summary For the Prompts
     */
    low_cost_prompts: Array<models.AiGovernancePromptSummary>;

}
